/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import LoadingBar from 'DesignSystem/LoadingBar/index'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'
import { DialogOverlay as ViewsModalOverlay, DialogContent as ViewsModalOverlayContent } from '@reach/dialog'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/App/Account/Loading"
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
  return (<React.Fragment
>
<ViewsModalOverlay
  data-testid="Loading.Vertical"
  data-view-path={viewPath}
 isOpen={true}
 style={{'--jc-3-2mx3jB': isMedia.mobile ? "flex-start" : "center",'--pt-4-2mx3jB': isMedia.mobile ? typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs : "0px",'--bf-2-2mx3jB': isBefore ? "blur(0px)" : "blur(10px)",'--bc-1-2mx3jB': isBefore ? dtColorsWhite : dtColorsNeutral500}}
 className={`views-block ${styles.Vertical}`}
>
<LoadingBar
  viewPath={`${viewPath}/LoadingBar`}
 height={dtSpaceXl}
 width={300}
 borderTopLeftRadius={dtSpaceXs}
 borderTopRightRadius={dtSpaceXs}
 borderBottomLeftRadius={dtSpaceXs}
 borderBottomRightRadius={dtSpaceXs}
/>
</ViewsModalOverlay>
{children}
</React.Fragment>)
}